import { type BrandRequestId, type Model, pendingBrandRequestOf } from '@rock/types';

/** The models still waiting on this request: not merged away, and still held by it. */
export function waitingModelsFor(models: readonly Model[], requestId: BrandRequestId): Model[] {
    return models.filter((model) => !model.mergedInto && pendingBrandRequestOf(model) === requestId);
}

/** How many models each request holds up, from one query over every waiting model. */
export function waitingModelCounts(models: readonly Model[]): Map<BrandRequestId, number> {
    const counts = new Map<BrandRequestId, number>();
    for (const model of models) {
        const requestId = model.mergedInto ? undefined : pendingBrandRequestOf(model);
        if (requestId) counts.set(requestId, (counts.get(requestId) ?? 0) + 1);
    }
    return counts;
}
